module.exports = __webpack_public_path__ + "img/pw.b805f38a.svg";